import { useEffect, DependencyList } from 'react';

export const useBroadcast = <T extends DependencyList>(deps: T, callback: (...deps: T) => void) => {
  useEffect(() => {
    callback(...deps);
  }, deps);
};
